<script>
export default {
    props: [
        'accountInfo',
        'method'
    ],
    data() {
        return {
            lead: false,
            canxall: false
        };
    },
}
</script>
<template>
    <div>
        <div class="row-fluid">
            <b-form-group label="Are you the lead client on this booking?" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="lead" :aria-describedby="ariaDescribedby" name="lead" value="Yes">Yes
                </b-form-radio>
                <b-form-radio v-model="lead" :aria-describedby="ariaDescribedby" name="lead" value="No">No
                </b-form-radio>
            </b-form-group>
        </div>
        <div class="row-fluid">
            <b-form-group label="Are you cancelling the booking for all people travelling?"
                v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="canxall" :aria-describedby="ariaDescribedby" name="canxall" value="Yes">Yes
                </b-form-radio>
                <b-form-radio v-model="canxall" :aria-describedby="ariaDescribedby" name="canxall" value="No">No
                </b-form-radio>
            </b-form-group>
        </div>
        <div class="row-fluid">
            <div class="col-md-12 text-danger" v-if="canxall === 'No' || lead === 'No'">As you answered no to one or more of the
                above questions, you will need to speak to one of our consultants to further your request.</div>
                  <button 
                  v-if="canxall === 'Yes' && lead === 'Yes'"
                  class="btn btn-info m-auto" 
        @click="$emit('nextStage', 3)">
            Proceed with Cancellation
        </button>
        </div>

    </div>

</template>